export default {
  type: "Feature",
  properties: {
    name: "Багануур",
    location: [47.78282, 108.3624],
  },
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [108.270864009367, 47.9883069809824],
        [108.27128749742, 47.9879061189723],
        [108.271598286032, 47.9875833630818],
        [108.271830121363, 47.9873425965836],
        [108.272049191717, 47.9871406861937],
        [108.272102562883, 47.9871014811485],
        [108.272152721671, 47.9870614487269],
        [108.272201435248, 47.9870187444196],
        [108.272249288174, 47.9869728556129],
        [108.272296534957, 47.9869235349932],
        [108.272348608402, 47.9868644324476],
        [108.272401384217, 47.9867995283756],
        [108.272456047708, 47.9867274117407],
        [108.272517139554, 47.98664210385],
        [108.272605815406, 47.9865104646862],
        [108.272709884054, 47.9863442663748],
        [108.272735666718, 47.9862969971088],
        [108.272754883431, 47.9862458310803],
        [108.27276976811, 47.9861828542554],
        [108.272790339203, 47.9860593359696],
        [108.27280114096, 47.9859517653617],
        [108.272809638654, 47.9858260949983],
        [108.272811193582, 47.9857526959302],
        [108.272809054095, 47.9856701579515],
        [108.272799275766, 47.9854749241285],
        [108.272798424108, 47.9853781247007],
        [108.272804283191, 47.9852855907575],
        [108.272817943893, 47.9852004132685],
        [108.27283533858, 47.9851199707101],
        [108.27285332682, 47.9850516761939],
        [108.272873420372, 47.9849898253202],
        [108.272896046415, 47.9849332309839],
        [108.272923893023, 47.984875191437],
        [108.27295905022, 47.9848110239097],
        [108.273013342292, 47.9847208578813],
        [108.273065562326, 47.9846390753331],
        [108.273274796795, 47.9843388033931],
        [108.273476135216, 47.9840614200985],
        [108.27351690688, 47.9840111983582],
        [108.273562989041, 47.9839604676015],
        [108.273615022915, 47.9839075685795],
        [108.273666767208, 47.9838594602459],
        [108.273743125045, 47.9837959384318],
        [108.273822904803, 47.9837366119551],
        [108.273903806016, 47.9836832120107],
        [108.273985970776, 47.9836355911097],
        [108.27406018463, 47.9835981352458],
        [108.274143801795, 47.9835616245694],
        [108.274251922788, 47.9835197656247],
        [108.274380252447, 47.9834740449912],
        [108.27446875383, 47.9834457658095],
        [108.27454880968, 47.9834235111861],
        [108.274631246035, 47.9834046299198],
        [108.274727325106, 47.9833863440046],
        [108.275041902562, 47.9833347660866],
        [108.275204785073, 47.9833098009066],
        [108.275378111411, 47.9832850920334],
        [108.275658358147, 47.9832492477547],
        [108.275861443051, 47.9832139475657],
        [108.275937360221, 47.983198064639],
        [108.27600456296, 47.9831818750435],
        [108.276052985157, 47.9831676279837],
        [108.276193409798, 47.9831219550143],
        [108.276236497217, 47.9831107359718],
        [108.276287302617, 47.9831004090567],
        [108.276352890174, 47.9830898438213],
        [108.276425648925, 47.9830808775805],
        [108.276506434125, 47.9830732971949],
        [108.276614723291, 47.9830652824369],
        [108.276718543726, 47.9830601580999],
        [108.276803132159, 47.9830604872517],
        [108.276907622589, 47.9830679318396],
        [108.276947885237, 47.9830729716403],
        [108.276983574832, 47.9830792722906],
        [108.277017699607, 47.9830876548714],
        [108.277056812922, 47.9831001554479],
        [108.277294699791, 47.9831842519517],
        [108.277423229998, 47.9832317640347],
        [108.277487820207, 47.9832482800841],
        [108.277561453998, 47.9832611547785],
        [108.27759999984, 47.9832654157664],
        [108.277636846863, 47.9832676164074],
        [108.277673344949, 47.9832678007684],
        [108.277712740651, 47.9832660641776],
        [108.277761405664, 47.9832617573243],
        [108.277832379261, 47.9832530482896],
        [108.277871766869, 47.9832463771187],
        [108.277904393373, 47.9832385404263],
        [108.277937806784, 47.9832267017509],
        [108.277973249966, 47.9832089059663],
        [108.278005184891, 47.9831878879107],
        [108.278032038648, 47.9831648283942],
        [108.27805616566, 47.9831371229799],
        [108.278071838145, 47.9831116038175],
        [108.278078773717, 47.9830893968582],
        [108.278078669395, 47.9830650477138],
        [108.278071302149, 47.9830362640124],
        [108.278057242148, 47.9830060297045],
        [108.278038037126, 47.982979538375],
        [108.278009651824, 47.9829494506567],
        [108.277981969792, 47.9829263695564],
        [108.27794419287, 47.982900607577],
        [108.277900588342, 47.9828735946407],
        [108.277841906679, 47.9828424718027],
        [108.277827766638, 47.9828302176405],
        [108.277814073561, 47.9828133931236],
        [108.277806085782, 47.9827993439146],
        [108.277801500139, 47.9827857866348],
        [108.277799648435, 47.9827704558919],
        [108.277800725823, 47.9827542087398],
        [108.277809682171, 47.9827268216855],
        [108.277818545889, 47.9827143705718],
        [108.277831461053, 47.9827009032241],
        [108.277897164623, 47.9826452261963],
        [108.277941402274, 47.9826136680864],
        [108.278003266637, 47.982577632252],
        [108.27808074593, 47.9825397492101],
        [108.278248286929, 47.9824667152668],
        [108.27843679742, 47.9823819946334],
        [108.27879973412, 47.9822321343056],
        [108.278945392816, 47.9821649027881],
        [108.278979363807, 47.982152056872],
        [108.279011424638, 47.9821422227854],
        [108.279047866966, 47.9821337592657],
        [108.279088340055, 47.9821265251191],
        [108.279166405705, 47.9821171847603],
        [108.279250569658, 47.9821121422616],
        [108.279333157999, 47.9821126189023],
        [108.279436258077, 47.9821178979227],
        [108.279509685024, 47.9821251320693],
        [108.279766398301, 47.9821558322259],
        [108.279935498724, 47.9821780481784],
        [108.280057954911, 47.9821980571946],
        [108.280271355938, 47.9822421041898],
        [108.280352891173, 47.9822541128371],
        [108.280434067578, 47.9822637796498],
        [108.280531779818, 47.9822714589607],
        [108.28062694158, 47.9822736667963],
        [108.280723569237, 47.9822711756743],
        [108.280844038821, 47.9822629702599],
        [108.280901236603, 47.9822553089354],
        [108.280950827918, 47.9822443138241],
        [108.281004109152, 47.9822279506594],
        [108.281091858702, 47.9821965031662],
        [108.281147926036, 47.9821739103977],
        [108.281209435167, 47.9821458821268],
        [108.281436215409, 47.9820341278727],
        [108.281523063838, 47.981989565566],
        [108.281569565083, 47.9819683487603],
        [108.281608964382, 47.9819538885612],
        [108.281661739298, 47.9819389571172],
        [108.281713566328, 47.981927420614],
        [108.281763833934, 47.9819193168231],
        [108.281805895226, 47.9819154632281],
        [108.281854386671, 47.9819137356304],
        [108.282019715338, 47.9819157752929],
        [108.282187648441, 47.9819260320608],
        [108.282345655727, 47.9819406028766],
        [108.28241903591, 47.9819429429125],
        [108.282746512342, 47.9819388599905],
        [108.282870483886, 47.9819322023093],
        [108.282972094687, 47.9819238557014],
        [108.283033861024, 47.9819166332461],
        [108.283090426582, 47.9819079943585],
        [108.283139777779, 47.9818983797065],
        [108.283191939357, 47.9818858269694],
        [108.283261129598, 47.9818663503518],
        [108.283416445213, 47.9818189138119],
        [108.28358843336, 47.9817629022362],
        [108.28369931707, 47.981734043891],
        [108.283755226123, 47.9817214749662],
        [108.283802909976, 47.9817127128714],
        [108.283845748283, 47.9817070489412],
        [108.283890700895, 47.9817036279201],
        [108.283992745169, 47.9817023023194],
        [108.284067023774, 47.9817067557622],
        [108.284127927662, 47.9817139764189],
        [108.284442538393, 47.9817576942622],
        [108.284495414032, 47.9817635722311],
        [108.284542453072, 47.9817669680712],
        [108.28463617412, 47.9817695482261],
        [108.284776455769, 47.9817686201258],
        [108.284829961833, 47.9817648726508],
        [108.284887546323, 47.9817559279937],
        [108.284954097953, 47.9817408049942],
        [108.285022613703, 47.9817212096661],
        [108.28507662069, 47.9817006592581],
        [108.285132369663, 47.9816743432963],
        [108.285205745349, 47.9816331480514],
        [108.285403053009, 47.9815117179915],
        [108.285551505897, 47.9814147971552],
        [108.285593024898, 47.9813913311451],
        [108.285633192218, 47.9813720298953],
        [108.285719742073, 47.9813366946328],
        [108.285804329606, 47.9813087239185],
        [108.285878210711, 47.9812902482464],
        [108.285962832419, 47.9812763429289],
        [108.286152412204, 47.9812540730171],
        [108.28626322217, 47.9812433971651],
        [108.28681871721, 47.9812036570232],
        [108.28723508713, 47.9811790308876],
        [108.287927720688, 47.981143860201],
        [108.288469352679, 47.9811119837311],
        [108.288646853669, 47.981105409687],
        [108.288805352885, 47.981103519312],
        [108.28891047284, 47.981105141689],
        [108.289154583018, 47.9811139361593],
        [108.289329342875, 47.9811142212443],
        [108.289518528757, 47.981109492609],
        [108.289730373058, 47.9810982016207],
        [108.289874328438, 47.9810861938728],
        [108.289933279897, 47.9810787618754],
        [108.289994026403, 47.981069070781],
        [108.290060866716, 47.9810563372802],
        [108.290130486833, 47.9810410146312],
        [108.290281154752, 47.9810019022161],
        [108.290389803647, 47.9809689924251],
        [108.29049866658, 47.9809302379402],
        [108.290612798642, 47.9808838778887],
        [108.290735376237, 47.9808285731801],
        [108.290901826358, 47.980746891356],
        [108.291124151359, 47.9806318446839],
        [108.291243670359, 47.9805645610057],
        [108.291342095761, 47.9805022667663],
        [108.291399198215, 47.9804615103905],
        [108.291452160189, 47.9804193483742],
        [108.291507040418, 47.9803710295994],
        [108.291565507142, 47.9803149622658],
        [108.2916974206, 47.980178584574],
        [108.29173457609, 47.9801378057152],
        [108.291784236653, 47.9800781977507],
        [108.291902133277, 47.9799288140635],
        [108.291969561746, 47.9798521162822],
        [108.292011131109, 47.9798108266084],
        [108.292061369037, 47.9797655556359],
        [108.292115742048, 47.9797204213604],
        [108.292175991229, 47.979673871552],
        [108.292251134982, 47.9796194643669],
        [108.292339214583, 47.9795591189582],
        [108.292594612152, 47.9793911220027],
        [108.292868292038, 47.9792066566619],
        [108.293024007852, 47.9791053921002],
        [108.293228973239, 47.97897920013],
        [108.293411085953, 47.9788713120615],
        [108.293652389346, 47.9787321455721],
        [108.29377240837, 47.9786577032904],
        [108.293842047373, 47.9786100059471],
        [108.293916978886, 47.9785553406565],
        [108.294176998969, 47.9783538637399],
        [108.294284254815, 47.9782743762615],
        [108.294400469706, 47.9781961541293],
        [108.294456266344, 47.9781621993261],
        [108.294511904701, 47.9781308291745],
        [108.294684132067, 47.9780420642899],
        [108.294891233344, 47.9779419625516],
        [108.294937114057, 47.9779217071211],
        [108.294965272729, 47.977911385602],
        [108.294995111335, 47.9779025380717],
        [108.295135599828, 47.9778708036947],
        [108.295245691236, 47.97783919882],
        [108.295400403406, 47.9777897253156],
        [108.295554667714, 47.9777336597807],
        [108.295706975097, 47.9776730481727],
        [108.296015100816, 47.9775443120204],
        [108.296268940759, 47.9774406705505],
        [108.296903728125, 47.9771742356025],
        [108.297053063248, 47.977114046676],
        [108.297390532047, 47.9769816098135],
        [108.297538055037, 47.9769287557575],
        [108.29772964121, 47.9768690722499],
        [108.29783512629, 47.9768423515933],
        [108.297902504397, 47.9768287097772],
        [108.297966832004, 47.9768177002767],
        [108.29804321862, 47.9768076008901],
        [108.298119992843, 47.976801400964],
        [108.298207198304, 47.9767975887378],
        [108.298397123429, 47.9767922602547],
        [108.298466720163, 47.9767926541577],
        [108.298544997154, 47.9767961138496],
        [108.29861763, 47.9768017022368],
        [108.298684408259, 47.9768094453996],
        [108.298740881187, 47.9768185087672],
        [108.298789108231, 47.9768294912881],
        [108.298947039974, 47.9768775060921],
        [108.299002690921, 47.9768923053357],
        [108.299177679207, 47.9769263689568],
        [108.299351704318, 47.9769644219705],
        [108.299434400577, 47.9769787499694],
        [108.299796267084, 47.9770296192216],
        [108.299993016265, 47.9770586277535],
        [108.300082478124, 47.9770733496554],
        [108.300195179364, 47.9770945475753],
        [108.300269990368, 47.9771111211813],
        [108.300341550322, 47.9771309296487],
        [108.300416432373, 47.9771557464406],
        [108.300506020137, 47.9771902444343],
        [108.300593320026, 47.9772285492582],
        [108.300657835591, 47.9772629015617],
        [108.300721646986, 47.9773032973094],
        [108.300778153189, 47.9773444008235],
        [108.300837281815, 47.9773923463798],
        [108.300898031019, 47.9774458029815],
        [108.301069170206, 47.9776024882643],
        [108.30112503879, 47.9776496604036],
        [108.301177439587, 47.9776901766604],
        [108.301439770929, 47.9778791044372],
        [108.301604753357, 47.9779926186645],
        [108.301762373035, 47.9780927347919],
        [108.301837746115, 47.9781369733427],
        [108.301910753978, 47.9781773016412],
        [108.302001988401, 47.9782238019869],
        [108.302100304086, 47.9782697834238],
        [108.302206722662, 47.9783157252905],
        [108.302323317067, 47.9783625269092],
        [108.302542007907, 47.978443515356],
        [108.302945775627, 47.978584007446],
        [108.303101639829, 47.9786397483258],
        [108.303257263912, 47.9786987636371],
        [108.303394988788, 47.9787583608098],
        [108.303430638813, 47.9787710457472],
        [108.303464054922, 47.9787804760382],
        [108.303529092094, 47.978792625879],
        [108.303648892582, 47.9788078136298],
        [108.303737074706, 47.9788145072837],
        [108.303833204139, 47.9788175928577],
        [108.303983994366, 47.9788162411766],
        [108.304313225375, 47.9788048440683],
        [108.304614401134, 47.9788021685853],
        [108.304752117017, 47.9787973886886],
        [108.304820195696, 47.9787925179604],
        [108.304885199592, 47.9787857703471],
        [108.304957421448, 47.9787761098297],
        [108.305039653657, 47.9787630867471],
        [108.305389864051, 47.9787006063479],
        [108.305482117406, 47.978681296105],
        [108.305566167145, 47.9786606161945],
        [108.305672969732, 47.9786304987985],
        [108.30577925341, 47.978596439674],
        [108.305884429123, 47.9785586168867],
        [108.305986831327, 47.9785176338818],
        [108.306072064574, 47.9784794028022],
        [108.306161533628, 47.9784351318759],
        [108.306257394163, 47.9783838156606],
        [108.306370711439, 47.978319538416],
        [108.306439470006, 47.9782785392232],
        [108.306508683629, 47.9782342673976],
        [108.306579707588, 47.9781858613884],
        [108.306653925039, 47.9781323706125],
        [108.306777854315, 47.9780377763224],
        [108.307145298417, 47.9777472782144],
        [108.307259541994, 47.9776541300341],
        [108.307382266179, 47.9775494930147],
        [108.307872337339, 47.9771119566515],
        [108.30798735793, 47.9770121876624],
        [108.308092742286, 47.9769240037398],
        [108.308205732209, 47.9768336758335],
        [108.308315153622, 47.9767509184202],
        [108.308400367983, 47.9766901979943],
        [108.30855950122, 47.9765858199797],
        [108.308600577755, 47.9765553059826],
        [108.308635725958, 47.9765255042487],
        [108.308675084787, 47.9764876427905],
        [108.308717377205, 47.9764423682208],
        [108.30880498736, 47.9763412970133],
        [108.308849990335, 47.9762862800878],
        [108.308946067607, 47.9761569270007],
        [108.309166185671, 47.9758405760818],
        [108.309207443869, 47.9757896933397],
        [108.309259205248, 47.9757356108099],
        [108.309320397818, 47.9756784211223],
        [108.309535798039, 47.9754859841909],
        [108.309648950739, 47.9753891254078],
        [108.309765130556, 47.9752936120107],
        [108.30989206087, 47.9751934796954],
        [108.310022129818, 47.9750951127493],
        [108.310155181816, 47.974998627185],
        [108.310291054988, 47.9749041408135],
        [108.310499549315, 47.9747665670235],
        [108.310890130275, 47.974521152829],
        [108.311038557983, 47.974433908698],
        [108.311106059297, 47.9743973989209],
        [108.311171263743, 47.974364430674],
        [108.311236326995, 47.9743339859248],
        [108.31130049722, 47.9743064918512],
        [108.311404800591, 47.9742655951811],
        [108.31146348765, 47.9742450861419],
        [108.311495061048, 47.9742358941712],
        [108.311526720782, 47.9742286402396],
        [108.311639940031, 47.9742094208282],
        [108.311681948263, 47.9742007819406],
        [108.311755022676, 47.9741808142932],
        [108.311818349337, 47.9741602710797],
        [108.311862468278, 47.974143276591],
        [108.311903748959, 47.9741244987467],
        [108.312018568102, 47.9740625489475],
        [108.312077911666, 47.9740269861566],
        [108.31215456718, 47.9739780000847],
        [108.31222362522, 47.9739286111165],
        [108.312266574143, 47.9738936580659],
        [108.31231183972, 47.9738536724091],
        [108.312486154413, 47.9736861646848],
        [108.312565480013, 47.9736159393242],
        [108.312611555879, 47.9735797748867],
        [108.312657126325, 47.9735477716124],
        [108.312702071743, 47.9735198908303],
        [108.312752058761, 47.9734926647547],
        [108.312847735834, 47.9734455429775],
        [108.312977380302, 47.9733864314387],
        [108.313090945791, 47.9733383581788],
        [108.313202882607, 47.9732946304429],
        [108.313309587168, 47.9732564632152],
        [108.313415154985, 47.9732221999446],
        [108.313509031617, 47.9731947409446],
        [108.313647334757, 47.9731578552509],
        [108.313691757669, 47.9731500320484],
        [108.313744013675, 47.9731452602456],
        [108.313920977771, 47.9731350538397],
        [108.314070364156, 47.9731310203803],
        [108.314284347045, 47.9731318936221],
        [108.314785879165, 47.9731431459395],
        [108.314914189938, 47.9731434229307],
        [108.315030043302, 47.9731413032286],
        [108.315253534723, 47.9731311363929],
        [108.315323668353, 47.9731266056084],
        [108.315403660351, 47.9731171627269],
        [108.315487906142, 47.9731026575616],
        [108.315530080749, 47.9730929107093],
        [108.315567306386, 47.9730820828719],
        [108.315685928763, 47.9730393722693],
        [108.315759503199, 47.9730092647658],
        [108.315834300712, 47.9729733629304],
        [108.315902695053, 47.9729362254265],
        [108.315976370213, 47.9728923250208],
        [108.316217422696, 47.9727359985676],
        [108.316310750741, 47.9726785372847],
        [108.316408187788, 47.9726249943481],
        [108.316500739717, 47.9725819357078],
        [108.316565830849, 47.9725566422753],
        [108.316667404777, 47.9725225489765],
        [108.31673046344, 47.9725028187501],
        [108.316783053095, 47.9724889431103],
        [108.316851731622, 47.9724755845806],
        [108.316914295658, 47.9724664052005],
        [108.316962919303, 47.9724627944225],
        [108.317006640744, 47.9724636757581],
        [108.317067863891, 47.9724711868958],
        [108.3171510242, 47.972487747012],
        [108.317203561695, 47.9725025012895],
        [108.31731794197, 47.9725411856273],
        [108.317380759614, 47.9725582601556],
        [108.317508107213, 47.9725874611425],
        [108.317639071886, 47.9726114613499],
        [108.317728104768, 47.9726219033782],
        [108.317838034298, 47.9726288137688],
        [108.318005301004, 47.9726355353018],
        [108.318176630847, 47.9726355865631],
        [108.318252732378, 47.9726391559723],
        [108.318315148026, 47.9726472129985],
        [108.318381432557, 47.9726589347621],
        [108.318426733207, 47.9726703093873],
        [108.318465467008, 47.9726841139807],
        [108.318517537754, 47.9727093066892],
        [108.318576873224, 47.9727450790222],
        [108.318672543103, 47.9728165148703],
        [108.318739740447, 47.972869923808],
        [108.318805882885, 47.9729259848464],
        [108.318876998575, 47.9729895462306],
        [108.319121988289, 47.9732199993036],
        [108.319222633218, 47.9733112229346],
        [108.319320423699, 47.9733935549687],
        [108.319423500394, 47.9734756252999],
        [108.319462734218, 47.9735042390295],
        [108.319512015267, 47.9735341109105],
        [108.319569404604, 47.9735636221635],
        [108.319633691742, 47.973592163048],
        [108.319706749067, 47.9736205897185],
        [108.319773201772, 47.9736433308751],
        [108.3198347154, 47.9736609953587],
        [108.319891062423, 47.9736737018799],
        [108.319952995135, 47.9736837976692],
        [108.320001348084, 47.9736893689692],
        [108.320050453765, 47.9736931083503],
        [108.320099865217, 47.9736949681483],
        [108.320147951067, 47.9736948926052],
        [108.32019735982, 47.9736927989836],
        [108.320248256052, 47.9736886908804],
        [108.320301896116, 47.9736823704451],
        [108.320348724714, 47.973674992407],
        [108.320412661115, 47.9736611653305],
        [108.320480458307, 47.9736423137418],
        [108.32055366402, 47.9736180743147],
        [108.320641239102, 47.9735854873804],
        [108.320693225312, 47.9735650970516],
        [108.320727075794, 47.9735496044307],
        [108.320843570375, 47.9734857201899],
        [108.320884996745, 47.9734650070045],
        [108.320926596685, 47.9734481366223],
        [108.320966941171, 47.9734363546041],
        [108.321016173658, 47.9734263757267],
        [108.321073375936, 47.9734182746337],
        [108.321147479173, 47.9734110171048],
        [108.321236584901, 47.9734046031399],
        [108.32129803018, 47.9734022019501],
        [108.321353548927, 47.9734021857623],
        [108.321404133994, 47.9734045114091],
        [108.321453637176, 47.9734093776407],
        [108.321510144278, 47.9734176190279],
        [108.321565108143, 47.9734284117918],
        [108.321619315679, 47.9734420940774],
        [108.321660841874, 47.9734555911027],
        [108.321695448686, 47.9734703381856],
        [108.321732198582, 47.9734891942709],
        [108.32187811898, 47.9735754239667],
        [108.32194750977, 47.9736075567434],
        [108.322014334794, 47.9736344167949],
        [108.322093072238, 47.9736635152591],
        [108.322428073297, 47.9737793569319],
        [108.322620499437, 47.9738411898191],
        [108.322796209877, 47.9738922848011],
        [108.322968808664, 47.9739364972716],
        [108.323157436966, 47.9739789443728],
        [108.323378394098, 47.9740229203215],
        [108.3236409107, 47.9740698991066],
        [108.323845912959, 47.9741027126701],
        [108.324025857407, 47.9741268279908],
        [108.324142291733, 47.9741390533746],
        [108.324276826714, 47.9741502733165],
        [108.324982704588, 47.9741987215938],
        [108.325190222251, 47.9742179805754],
        [108.325313968065, 47.974233332902],
        [108.325393863836, 47.9742475385931],
        [108.325480063854, 47.9742678605734],
        [108.325565842989, 47.9742918338011],
        [108.32579444166, 47.9743605438041],
        [108.325864149011, 47.9743789790067],
        [108.325927676221, 47.974393378052],
        [108.326105597196, 47.9744272842918],
        [108.326252190286, 47.9744512997877],
        [108.326385692846, 47.9744683985978],
        [108.326509585249, 47.9744789422494],
        [108.326628576348, 47.9744836528983],
        [108.326758386291, 47.9744840899688],
        [108.326911039913, 47.9744802939305],
        [108.327010950095, 47.9744726559883],
        [108.327082852692, 47.9744617642991],
        [108.327165486898, 47.9744444577456],
        [108.327390233772, 47.9743902124384],
        [108.327551803273, 47.9743464532263],
        [108.327619197568, 47.9743318896051],
        [108.327668054137, 47.974324857806],
        [108.327726978617, 47.9743203288202],
        [108.327792819783, 47.9743184357472],
        [108.327874104107, 47.9743188970995],
        [108.32795879776, 47.9743226328832],
        [108.328064566127, 47.9743314093671],
        [108.328197831265, 47.9743451968734],
        [108.328317818812, 47.9743609970624],
        [108.328432868182, 47.9743817938847],
        [108.328660976723, 47.9744331433749],
        [108.328758456038, 47.9744525309596],
        [108.328962803591, 47.9744848031312],
        [108.329164055677, 47.9745102611397],
        [108.329355741674, 47.9745283617945],
        [108.329543229636, 47.9745399450625],
        [108.329727785809, 47.974545107171],
        [108.329909969569, 47.9745438031541],
        [108.330061525119, 47.9745376059258],
        [108.330210144383, 47.9745267861823],
        [108.3303565702, 47.9745113016553],
        [108.330500193729, 47.9744912278879],
        [108.330641729033, 47.974466466854],
        [108.330780700369, 47.974437094996],
        [108.330917266918, 47.9744030853342],
        [108.331051553686, 47.974364400097],
        [108.331146680375, 47.9743336927458],
        [108.331239153164, 47.9743010473555],
        [108.331358266571, 47.9742557952688],
        [108.331458671381, 47.974214430052],
        [108.33152559533, 47.97418382972],
        [108.331588689966, 47.974151511683],
        [108.331664852651, 47.9741081598638],
        [108.331721410115, 47.9740728102121],
        [108.33178640322, 47.9740258017494],
        [108.331833544782, 47.9739829976173],
        [108.331852989024, 47.9739602456689],
        [108.331873298414, 47.9739324512217],
        [108.331936073791, 47.9738291739773],
        [108.331989195845, 47.9737590934075],
        [108.332042051699, 47.9737023605755],
        [108.332091425379, 47.9736533142491],
        [108.332140931259, 47.973608784318],
        [108.332192547848, 47.9735672329415],
        [108.33225735839, 47.9735236023324],
        [108.332329656688, 47.9734839143512],
        [108.332414191162, 47.973443774011],
        [108.332599557624, 47.9733612090526],
        [108.332694811117, 47.9733128641974],
        [108.332914000181, 47.9731913478025],
        [108.333035318725, 47.9731191871008],
        [108.3330939842, 47.9730813148508],
        [108.333144785104, 47.9730461486609],
        [108.333189976936, 47.9730125176137],
        [108.333235102218, 47.9729760438094],
        [108.333284044223, 47.9729333008312],
        [108.333330218115, 47.972889996676],
        [108.333419617022, 47.9727971416748],
        [108.333484555268, 47.9727227155809],
        [108.333539877963, 47.9726557205851],
        [108.333598047912, 47.9725804329407],
        [108.333617665723, 47.9725492840223],
        [108.333635742096, 47.9725074700438],
        [108.333648044821, 47.9724559856552],
        [108.333648941446, 47.9724217763439],
        [108.33364075042, 47.9723915519286],
        [108.333621999556, 47.9723611638367],
        [108.333588586144, 47.9723244328264],
        [108.333555808554, 47.9722949854253],
        [108.333520020033, 47.9722705490466],
        [108.333464530064, 47.9722431296168],
        [108.33332859304, 47.9721901631456],
        [108.333283099935, 47.972170368168],
        [108.333176033847, 47.972116352188],
        [108.333139432339, 47.972094014827],
        [108.333108652143, 47.9720686683344],
        [108.333077077845, 47.9720333366692],
        [108.333059952055, 47.9720048137712],
        [108.333053703566, 47.9719810869577],
        [108.333053828571, 47.9719619017204],
        [108.333059008666, 47.9719371361899],
        [108.333076719015, 47.9718870286635],
        [108.333090862653, 47.971854829337],
        [108.333121432408, 47.9718033674315],
        [108.333176430448, 47.9717269088698],
        [108.333210582203, 47.9716729153728],
        [108.333247722405, 47.9716075058818],
        [108.333262586399, 47.9715685472507],
        [108.333266496652, 47.9715349863506],
        [108.333261413683, 47.9714866693744],
        [108.333251961809, 47.9714386716574],
        [108.33322281568, 47.9713175041995],
        [108.333215425951, 47.9712619773584],
        [108.333217444929, 47.9712339589801],
        [108.333224119697, 47.9712091601747],
        [108.333236880178, 47.9711799690804],
        [108.333256608606, 47.97114636861],
        [108.333285031679, 47.9711060681905],
        [108.333314261444, 47.9710710279057],
        [108.333346001217, 47.971039182912],
        [108.333383914836, 47.9710062920068],
        [108.333436044038, 47.9709662389009],
        [108.333510647299, 47.9709136069774],
        [108.3335710026, 47.9708750989067],
        [108.333630038595, 47.9708413581422],
        [108.333735490401, 47.9707867899784],
        [108.333844909115, 47.9707332272567],
        [108.333945428139, 47.9706868519167],
        [108.334072371043, 47.9706310930505],
        [108.334290668879, 47.9705411167791],
        [108.334377931896, 47.9705073571289],
        [108.33454359691, 47.9704470180155],
        [108.334660401756, 47.9703987603945],
        [108.334726653912, 47.9703647003707],
        [108.334793396198, 47.97032475968],
        [108.334855367581, 47.9702832307865],
        [108.334911369264, 47.9702400507378],
        [108.334941975892, 47.9702129883388],
        [108.334969285604, 47.9701849510747],
        [108.33499401786, 47.9701545378017],
        [108.335017331884, 47.9701207340847],
        [108.335056043202, 47.9700537840549],
        [108.335119913953, 47.9699315922692],
        [108.335206764181, 47.9697885344134],
        [108.335332589228, 47.9695696798968],
        [108.33541957975, 47.9694329559662],
        [108.335493405996, 47.9693321185825],
        [108.335537551017, 47.9692788544356],
        [108.335592176738, 47.9692186825962],
        [108.335656296601, 47.9691520005644],
        [108.335716954974, 47.969093155225],
        [108.335830747991, 47.9689894552992],
        [108.33590019184, 47.9689293302244],
        [108.335965341427, 47.9688771821363],
        [108.336015339237, 47.9688451527816],
        [108.336051882289, 47.9688274451306],
        [108.336089741948, 47.9688135380144],
        [108.336140907077, 47.9687986650264],
        [108.33619328809, 47.9687871986703],
        [108.336239802825, 47.9687801587774],
        [108.336282427992, 47.9687766676092],
        [108.336329307851, 47.96877612262],
        [108.336378007039, 47.9687784590587],
        [108.336458484671, 47.9687860880076],
        [108.336528811655, 47.9687974077742],
        [108.336626274783, 47.9688199825562],
        [108.336811557607, 47.9688687599854],
        [108.336895787211, 47.9688886412978],
        [108.337001507014, 47.968908703374],
        [108.33712615215, 47.9689247292929],
        [108.337231713673, 47.968935503171],
        [108.337366040011, 47.9689468283335],
        [108.337642239798, 47.9689641213972],
        [108.337895675945, 47.9689748682956],
        [108.338012087788, 47.9689780689828],
        [108.338163051584, 47.9689801104438],
        [108.338263638956, 47.9689842392313],
        [108.338332841787, 47.9689909553683],
        [108.338402755982, 47.9690001266546],
        [108.338471382348, 47.9690113879652],
        [108.338523509752, 47.9690228030599],
        [108.338578020359, 47.9690396509592],
        [108.338623739194, 47.9690603218764],
        [108.338668549714, 47.9690880605656],
        [108.33871869681, 47.9691272898926],
        [108.338785366252, 47.9691854418547],
        [108.338859106163, 47.9692573273638],
        [108.338904205365, 47.9693110150913],
        [108.338969737164, 47.9694000605644],
        [108.33900906002, 47.9694499459583],
        [108.33904220993, 47.9694872741185],
        [108.339073061173, 47.9695170641612],
        [108.339120741429, 47.9695555290644],
        [108.339196655002, 47.9696074388323],
        [108.339273276341, 47.9696535686573],
        [108.339356590434, 47.9696982568691],
        [108.339464766286, 47.9697487466074],
        [108.339578083562, 47.969793825125],
        [108.33969763224, 47.969834453797],
        [108.33982004436, 47.9698689463948],
        [108.339953910245, 47.9698993668624],
        [108.340090966925, 47.969924146782],
        [108.340234136296, 47.9699443167768],
        [108.34037772835, 47.9699585836218],
        [108.340473293907, 47.9699648141249],
        [108.340569426938, 47.9699685130365],
        [108.340665042857, 47.9699696461823],
        [108.340760567946, 47.9699681991731],
        [108.340850114341, 47.9699641549219],
        [108.340940870325, 47.9699575763811],
        [108.341039698623, 47.9699480768423],
        [108.341149407819, 47.9699353973008],
        [108.341246815188, 47.9699218975776],
        [108.341342996782, 47.9699060838987],
        [108.341572903067, 47.969861814771],
        [108.341739154438, 47.9698270379874],
        [108.341977426217, 47.9697702386057],
        [108.342142382565, 47.9697365500018],
        [108.342268603313, 47.9697150526076],
        [108.342342961059, 47.9697039037122],
        [108.342412613551, 47.9696959087393],
        [108.342485828258, 47.9696909228978],
        [108.342556547347, 47.9696888202829],
        [108.342626253799, 47.9696890891802],
        [108.342689322354, 47.9696914867728],
        [108.342751106678, 47.9696965337681],
        [108.342842723313, 47.9697102007652],
        [108.342983354798, 47.9697375392561],
        [108.343113490295, 47.9697586652302],
        [108.343254184733, 47.9697773423505],
        [108.34339462826, 47.9697917449931],
        [108.343502054077, 47.9697983460169],
        [108.343615395634, 47.969801739159],
        [108.343705608427, 47.9698001941237],
        [108.343788679704, 47.9697940733379],
        [108.343883086036, 47.9697819828523],
        [108.344001852304, 47.9697613595991],
        [108.34411173327, 47.9697373953646],
        [108.344211209979, 47.9697110812015],
        [108.344323800603, 47.9696758736427],
        [108.344460904048, 47.969627091717],
        [108.344582327812, 47.969579923175],
        [108.344700612044, 47.9695293938665],
        [108.344771581144, 47.9694958977175],
        [108.344848862585, 47.9694567367391],
        [108.344925826566, 47.9694150090954],
        [108.345005559559, 47.9693693846894],
        [108.345152461117, 47.9692795918797],
        [108.345446084369, 47.9690902450188],
        [108.345546517957, 47.9690201392681],
        [108.345612977857, 47.9689694696653],
        [108.345684910131, 47.9689108401632],
        [108.34583238006, 47.9687842803703],
        [108.345935087135, 47.9687012126909],
        [108.346019643192, 47.9686398150754],
        [108.346109113145, 47.9685838781435],
        [108.346154813094, 47.9685591341968],
        [108.346200606573, 47.96853667183],
        [108.346316723438, 47.9684879636487],
        [108.346397607564, 47.9684572347136],
        [108.346540145611, 47.9684059490754],
        [108.346754955877, 47.9683311101927],
        [108.346841012003, 47.9682973838173],
        [108.346921565178, 47.9682619676158],
        [108.347053873438, 47.9681975662647],
        [108.347180700329, 47.9681300919303],
        [108.347319009765, 47.968051448016],
        [108.347447298954, 47.9679724830437],
        [108.347537311198, 47.9679131160974],
        [108.347624131748, 47.9678523552021],
        [108.347704919646, 47.9677924018979],
        [108.34777573856, 47.9677355269731],
        [108.347831170072, 47.9676857800748],
        [108.347891431844, 47.9676268933665],
        [108.348056339628, 47.9674518196458],
        [108.348164016356, 47.9673455080888],
        [108.348237187896, 47.9672815698886],
        [108.348300991198, 47.9672293552506],
        [108.348357241993, 47.9671872157175],
        [108.348411079008, 47.9671525279668],
        [108.348464841379, 47.9671224366512],
        [108.34852529021, 47.9670924028921],
        [108.348583265905, 47.9670662802847],
        [108.348689033372, 47.9670218807552],
        [108.348892850325, 47.9669409993277],
        [108.348981384084, 47.9669076803452],
        [108.349130791153, 47.9668542714075],
        [108.349234137645, 47.9668132704161],
        [108.349279693703, 47.9667919438932],
        [108.349321888994, 47.9667691793542],
        [108.349367002585, 47.9667417518304],
        [108.349409715886, 47.9667129438473],
        [108.349468642164, 47.9666690533342],
        [108.349538637298, 47.966612210785],
        [108.349627403082, 47.9665379906358],
        [108.349706166606, 47.9664693606725],
        [108.349828735208, 47.9663558077743],
        [108.349870619334, 47.9663118722951],
        [108.349906354794, 47.9662698739556],
        [108.349942496749, 47.9662215120132],
        [108.349977091869, 47.9661688692979],
        [108.350007785731, 47.9661165926067],
        [108.35005270327, 47.9660330365954],
        [108.3501155407, 47.9659065739293],
        [108.350135235853, 47.9658616249141],
        [108.350168279642, 47.9657764663109],
        [108.350197604736, 47.9657168970172],
        [108.350219046372, 47.9656851320632],
        [108.350263337983, 47.9656276833709],
        [108.350288340934, 47.965601782896],
        [108.350316021167, 47.9655808961415],
        [108.350333530068, 47.9655715557827],
        [108.350351153183, 47.9655644592324],
        [108.350405710555, 47.9655513534123],
        [108.350655165404, 47.9655143472094],
        [108.350724107432, 47.9655016047153],
        [108.35079314209, 47.9654868819141],
        [108.350848383846, 47.9654737023495],
        [108.350894242975, 47.9654607952795],
        [108.350934477744, 47.9654471093966],
        [108.35097125462, 47.9654316608425],
        [108.351015649653, 47.9654086292049],
        [108.351065801246, 47.9653778202303],
        [108.351164511733, 47.965310033831],
        [108.351346056076, 47.9651894347447],
        [108.351463210759, 47.9651078293629],
        [108.351587664339, 47.965018158861],
        [108.35180929956, 47.9648506691231],
        [108.351877121932, 47.9648050456164],
        [108.351939111301, 47.9647700170227],
        [108.352077566427, 47.9647081517598],
        [108.352235375862, 47.9646440687688],
        [108.352566832693, 47.9645163776288],
        [108.353049270408, 47.9643375843121],
        [108.353230502686, 47.9642664200593],
        [108.353386545852, 47.9642010384472],
        [108.353483071886, 47.9641578916734],
        [108.353577071725, 47.9641133617423],
        [108.353795127643, 47.964004254193],
        [108.353990518847, 47.963899696314],
        [108.35406232072, 47.9638575333985],
        [108.354125858721, 47.96381715204],
        [108.354177097595, 47.9637817223486],
        [108.354225793186, 47.9637451289346],
        [108.354275981651, 47.9637044463032],
        [108.354324322909, 47.9636624281786],
        [108.354433198433, 47.96355830737],
        [108.354536239156, 47.963449895896],
        [108.354609220939, 47.9633688247116],
        [108.354671041236, 47.9632918040735],
        [108.354744255043, 47.9631901204278],
        [108.354849308449, 47.9630336320965],
        [108.354920213697, 47.9629330788985],
        [108.355018169653, 47.9628075821043],
        [108.35511012803, 47.9626962397397],
        [108.355208189207, 47.9625851716684],
        [108.35529106533, 47.9625012451364],
        [108.355411850577, 47.9623884827423],
        [108.355464179428, 47.9623443287278],
        [108.355512969448, 47.9623068126094],
        [108.35555410264, 47.9622782096717],
        [108.355596714317, 47.9622517857913],
        [108.355644131072, 47.962225621815],
        [108.355695298, 47.9622000720757],
        [108.355793289928, 47.962155590708],
        [108.355962706913, 47.9620827159446],
        [108.356114395563, 47.9620151381881],
        [108.356242505787, 47.9619561516551],
        [108.356372672761, 47.9618937575909],
        [108.356450804061, 47.9618527332171],
        [108.356528087301, 47.961809797784],
        [108.356709869965, 47.9617026561527],
        [108.356850122835, 47.9616122661932],
        [108.356979793383, 47.9615203833591],
        [108.357143714611, 47.9613957328269],
        [108.357446324788, 47.9611581832036],
        [108.357569610149, 47.9610670171292],
        [108.357712042077, 47.9609680809123],
        [108.357966880267, 47.9607964156221],
        [108.35821628925, 47.9606337957131],
        [108.358453759733, 47.9604847501711],
        [108.358695120683, 47.9603396256732],
        [108.358913430211, 47.9602150003221],
        [108.359016312653, 47.9601600688322],
        [108.359136078068, 47.9600986001703],
        [108.359412418149, 47.959963977056],
        [108.359903857177, 47.959732035605],
        [108.360094479277, 47.9596374134359],
        [108.360254429998, 47.9595534833066],
        [108.360453483242, 47.9594406228865],
        [108.360652852147, 47.9593212630659],
        [108.360882504824, 47.9591784660134],
        [108.361139418649, 47.9590135339475],
        [108.361285484737, 47.9589151364245],
        [108.361401594408, 47.9588299580362],
        [108.361525906795, 47.9587304480518],
        [108.361646731611, 47.9586256662416],
        [108.361765274848, 47.9585157987652],
        [108.361894625237, 47.9583894233333],
        [108.362240372295, 47.9580347433088],
        [108.362454662753, 47.9578231750995],
        [108.362535846352, 47.9577473820361],
        [108.362616425608, 47.9576752752937],
        [108.362713538899, 47.9575928749113],
        [108.362803586217, 47.9575215721629],
        [108.362871631621, 47.9574554908783],
        [108.362913877274, 47.9574220334002],
        [108.362935154334, 47.9574106578756],
        [108.362959096985, 47.9574022312281],
        [108.362991816119, 47.9573955447686],
        [108.363024528959, 47.9573918116828],
        [108.363050559836, 47.9573910877286],
        [108.363076171628, 47.9573927676622],
        [108.363104133349, 47.9573970700188],
        [108.363143361777, 47.9574056288667],
        [108.363180438127, 47.9574165097642],
        [108.363218052271, 47.9574329916393],
        [108.363261193649, 47.9574587859942],
        [108.36332452121, 47.9575036837481],
        [108.363369300253, 47.9575316202881],
        [108.363412691642, 47.9575531572524],
        [108.363488393874, 47.9575850616014],
        [108.363529902983, 47.95759775823],
        [108.363566026051, 47.9576035588572],
        [108.363604384835, 47.9576053413135],
        [108.363672744102, 47.9576031190887],
        [108.363780847108, 47.9575941969147],
        [108.363869056212, 47.9575814139511],
        [108.363960369775, 47.9575618006367],
        [108.364042101062, 47.9575373156946],
        [108.36416605462, 47.9574908270401],
        [108.364304107748, 47.9574316822264],
        [108.364408280718, 47.9573795287423],
        [108.364458338781, 47.9573509599789],
        [108.364501603366, 47.9573238472178],
        [108.364568152298, 47.9572761112036],
        [108.364633351348, 47.9572220862303],
        [108.364700423686, 47.9571604053285],
        [108.364763441879, 47.9570959877897],
        [108.364805631775, 47.9570455340242],
        [108.364850147317, 47.9569858280336],
        [108.364953554063, 47.956831511565],
        [108.365016149576, 47.9567441073547],
        [108.365098526576, 47.9566415963326],
        [108.365184854298, 47.9565397031448],
        [108.36529998011, 47.9564100973482],
        [108.365437172588, 47.956261916954],
        [108.365806170718, 47.9558777814345],
        [108.366018125636, 47.9556514418606],
        [108.366140786868, 47.9555137097899],
        [108.366281412058, 47.9553395713642],
        [108.366376863402, 47.9552312875939],
        [108.366438162991, 47.9551710222249],
        [108.366503416, 47.9551108710699],
        [108.366570807597, 47.9550522964264],
        [108.366621129162, 47.9550130796899],
        [108.366666858789, 47.9549821690919],
        [108.366713587562, 47.9549555212803],
        [108.366766262653, 47.9549302098613],
        [108.366826322976, 47.9549052527752],
        [108.366907815943, 47.9548770320495],
        [108.366991953816, 47.9548541479007],
        [108.367078042318, 47.9548365067994],
        [108.36716543034, 47.9548246411443],
        [108.367254381385, 47.9548190311734],
        [108.367342979895, 47.9548191741656],
        [108.367416573216, 47.9548238317545],
        [108.367522280429, 47.9548368431459],
        [108.36765076567, 47.9548559690278],
        [108.36777445123, 47.9548785842793],
        [108.367903166698, 47.9549069057292],
        [108.368038259258, 47.954941097054],
        [108.368208440667, 47.9549893618696],
        [108.368475036594, 47.9550711992764],
        [108.368595457614, 47.9551106399441],
        [108.368707684912, 47.9551518261959],
        [108.368777491188, 47.9551727839968],
        [108.36883532479, 47.9551837296455],
        [108.368895797004, 47.9551911751326],
        [108.368957985123, 47.9551956555551],
        [108.369018479819, 47.9551963381405],
        [108.369062489942, 47.9551910869991],
        [108.369140577176, 47.9551708540517],
        [108.369253864774, 47.9551359630543],
        [108.369352916104, 47.9551017339579],
        [108.369433904551, 47.9550705256843],
        [108.369526244241, 47.9550323485641],
        [108.369759385387, 47.9549298834074],
        [108.369894664107, 47.9548727350887],
        [108.370008229596, 47.9548289623868],
        [108.370119830066, 47.9547915353012],
        [108.370282224245, 47.9547466960033],
        [108.370382299903, 47.9547225932731],
        [108.370423659724, 47.9547140820893],
        [108.370471056694, 47.954707465777],
        [108.370517471604, 47.9547040906214],
        [108.370573552428, 47.9547026328203],
        [108.370627855291, 47.9547042192244],
        [108.370668360756, 47.9547076951041],
        [108.370703219378, 47.9547126881401],
        [108.370787590175, 47.9547329930332],
        [108.370902945315, 47.9547698841229],
        [108.371008912431, 47.9548103608096],
        [108.371128054616, 47.9548644361449],
        [108.371288721198, 47.9549470109958],
        [108.371429058604, 47.9550235855701],
        [108.37156833571, 47.9551056109353],
        [108.371612083231, 47.9551293854129],
        [108.371640071033, 47.9551415478442],
        [108.371667842997, 47.9551512767101],
        [108.371714512415, 47.9551653960662],
        [108.371768985251, 47.9551795388047],
        [108.371865546358, 47.9552017727437],
        [108.371946794709, 47.9552167959184],
        [108.372042702908, 47.9552304251441],
        [108.372146569209, 47.9552412457869],
        [108.37223711565, 47.9552481076141],
        [108.372382953311, 47.9552561322648],
        [108.372652379404, 47.9552664016232],
        [108.372840336812, 47.9552773607617],
        [108.372946913669, 47.9552792952034],
        [108.372991018221, 47.9552832351333],
        [108.373027815781, 47.9552913668032],
        [108.373063562034, 47.9553044078722],
        [108.373096639998, 47.9553202503293],
        [108.373121891162, 47.9553355522939],
        [108.37314768192, 47.9553559561125],
        [108.373182089982, 47.9553894630533],
        [108.373211575154, 47.9554218602307],
        [108.373250635409, 47.955471930885],
        [108.373274185955, 47.9555054818926],
        [108.373305315988, 47.9555634962584],
        [108.373328344028, 47.9556255027148],
        [108.373349505076, 47.9557075019997],
        [108.373381697208, 47.9558617519183],
        [108.373400136907, 47.9559229390924],
        [108.373423330422, 47.9559787249382],
        [108.3734577178, 47.956042245853],
        [108.373502481554, 47.956109970199],
        [108.373525016766, 47.9561346134217],
        [108.373549776001, 47.9561577826556],
        [108.373574486673, 47.9561775830291],
        [108.373600218975, 47.9561941908093],
        [108.373636157683, 47.9562116421536],
        [108.373675166676, 47.9562259116966],
        [108.373713711619, 47.9562361819543],
        [108.373753421183, 47.9562422361903],
        [108.373821870383, 47.9562443918653],
        [108.373891373588, 47.9562437425547],
        [108.373984371582, 47.9562402477892],
        [108.37403418503, 47.9562349318966],
        [108.374082129687, 47.9562263712501],
        [108.374141361735, 47.9562127051523],
        [108.374194648364, 47.9561986001853],
        [108.37425116356, 47.9561814069464],
        [108.374378389751, 47.9561357034],
        [108.374531468752, 47.9560744388843],
        [108.374616026608, 47.9560473207273],
        [108.374679700408, 47.9560327364217],
        [108.374747676564, 47.956020835693],
        [108.374812692152, 47.9560130781411],
        [108.374885683827, 47.9560077091885],
        [108.374940117992, 47.9560064843118],
        [108.374974595301, 47.9560082730634],
        [108.37500580987, 47.9560126653523],
        [108.375051393807, 47.9560232809497],
        [108.375103261307, 47.9560383805668],
        [108.375148142873, 47.956053723001],
        [108.375220256809, 47.9560823727034],
        [108.375296867357, 47.9561154758486],
        [108.37541286731, 47.9561686842375],
        [108.375502025198, 47.9562135846892],
        [108.375604824903, 47.9562701421534],
        [108.375713757984, 47.9563349562932],
        [108.37588984524, 47.9564473661531],
        [108.376173112799, 47.9566351050261],
        [108.37638485098, 47.9567647413997],
        [108.376464235036, 47.9568209148534],
        [108.376522826767, 47.9568689512412],
        [108.376543111875, 47.956893636732],
        [108.376555894839, 47.956922422232],
        [108.376568634635, 47.9569639574207],
        [108.376580226896, 47.957016921194],
        [108.376589682368, 47.9570789977976],
        [108.376601464386, 47.9571892393919],
        [108.376607452072, 47.9572742666941],
        [108.376608176027, 47.957341443353],
        [108.376613738333, 47.9573805458755],
        [108.376624534695, 47.9574064013844],
        [108.376642277419, 47.9574314484027],
        [108.37666716256, 47.9574578812762],
        [108.376696818603, 47.9574822915745],
        [108.376733494755, 47.9575051550389],
        [108.376776755743, 47.9575228474015],
        [108.376829467706, 47.9575366456997],
        [108.376915851186, 47.9575529171335],
        [108.376986519912, 47.9575634526912],
        [108.377096441348, 47.9575734684408],
        [108.377247069697, 47.9575814948901],
        [108.377359907634, 47.9575843043722],
        [108.377426441277, 47.9575896616336],
        [108.377474268123, 47.9575985370429],
        [108.377521517604, 47.9576111140617],
        [108.377567719375, 47.9576267307891],
        [108.37760994884, 47.9576450850527],
        [108.37764596399, 47.9576656876214],
        [108.377678166914, 47.9576900475577],
        [108.377711871706, 47.9577222495822],
        [108.377739719213, 47.957754371567],
        [108.377765310321, 47.9577948842266],
        [108.377830542645, 47.9579212677523],
        [108.377889828653, 47.9580230620148],
        [108.377942135921, 47.9580984449873],
        [108.377967923981, 47.9581297809647],
        [108.377992782141, 47.9581545527904],
        [108.378025532752, 47.9581811079718],
        [108.378064207197, 47.9582075786169],
        [108.378104657804, 47.9582310113522],
        [108.378147720041, 47.9582519628578],
        [108.37818445375, 47.958266420359],
        [108.378223100316, 47.9582786952056],
        [108.378278261133, 47.9582933442625],
        [108.378340874632, 47.9583071794328],
        [108.378443167119, 47.9583259887534],
        [108.378535040959, 47.9583379884075],
        [108.378642641245, 47.9583474690605],
        [108.378802555094, 47.9583566574339],
        [108.378928550113, 47.9583604993376],
        [108.37902605281, 47.9583598518258],
        [108.379132753774, 47.9583548857694],
        [108.379235102918, 47.9583454392907],
        [108.379288805934, 47.9583360539658],
        [108.37933807799, 47.95832275659],
        [108.379399683349, 47.9583007582734],
        [108.379459365058, 47.958276174406],
        [108.37953803775, 47.9582370862726],
        [108.379629877417, 47.9581851899946],
        [108.37975589312, 47.9581168379218],
        [108.379819282734, 47.958084688058],
        [108.37986786501, 47.9580632760994],
        [108.379914913942, 47.958046251933],
        [108.379967631301, 47.9580305362803],
        [108.38002577427, 47.9580159348875],
        [108.380106754623, 47.9579981939615],
        [108.380218685144, 47.9579756938232],
        [108.380313155328, 47.9579586993345],
        [108.380391928745, 47.9579470441208],
        [108.380472779595, 47.9579382352614],
        [108.380628305652, 47.9579281241836],
        [108.380745913593, 47.957923025927],
        [108.380859106762, 47.9579215195625],
        [108.381029566062, 47.957922757929],
        [108.381152647277, 47.9579193629883],
        [108.381212140128, 47.9579148106201],
        [108.381275490172, 47.9579070953362],
        [108.381344102149, 47.957896516611],
        [108.381413394912, 47.9578835618769],
        [108.381462408863, 47.957871576612],
        [108.381508261697, 47.9578570462657],
        [108.381555645177, 47.9578384141116],
        [108.38160149891, 47.9578171280581],
        [108.381659063615, 47.9577864863573],
        [108.381717920646, 47.9577516412253],
        [108.381774064422, 47.9577161782591],
        [108.381827000316, 47.9576794445508],
        [108.381881181771, 47.9576368643499],
        [108.381929381836, 47.9575915735923],
        [108.382069090616, 47.9574307990921],
        [108.382132652, 47.9573626520648],
        [108.38216670483, 47.957328985944],
        [108.382213974096, 47.9572884570967],
        [108.38226917808, 47.9572453723761],
        [108.38231682686, 47.9572123528678],
        [108.382365079085, 47.9571836501054],
        [108.382414953687, 47.9571592793773],
        [108.382474316137, 47.9571352800692],
        [108.382540687003, 47.9571111737417],
        [108.382622896729, 47.9570841760939],
        [108.382728093127, 47.9570521593297],
        [108.382841119022, 47.9570206048171],
        [108.3830173106, 47.9569809177352],
        [108.383104361377, 47.9569588240905],
        [108.383188310392, 47.9569307283705],
        [108.38327335658, 47.9568956907835],
        [108.383376435074, 47.9568475311887],
        [108.38347517434, 47.9567990307508],
        [108.383568684947, 47.9567510105508],
        [108.383637418332, 47.9567124512187],
        [108.383676790651, 47.9566876641045],
        [108.383716568565, 47.9566594496739],
        [108.383814704385, 47.9565821799237],
        [108.383873979601, 47.956538597878],
        [108.383932290743, 47.9565006392931],
        [108.384015912404, 47.9564503042382],
        [108.384064499177, 47.9564249145782],
        [108.384114074305, 47.9564031653738],
        [108.384169697374, 47.9563827210858],
        [108.384227816061, 47.9563648407648],
        [108.384309300034, 47.9563445106906],
        [108.384393982896, 47.9563281007613],
        [108.384485455639, 47.9563147827011],
        [108.384578489606, 47.9563052372969],
        [108.384663688678, 47.9562997199562],
        [108.384748385929, 47.9562981245588],
        [108.38482477974, 47.9563011849518],
        [108.384901641198, 47.9563088786519],
        [108.384970507683, 47.9563191030442],
        [108.385042346427, 47.9563325721905],
        [108.385093194096, 47.9563437246832],
        [108.385144864644, 47.9563578719183],
        [108.385241282759, 47.9563920173778],
        [108.385363621134, 47.9564427049669],
        [108.385440710121, 47.9564721838442],
        [108.385506614239, 47.9564937289025],
        [108.385627296063, 47.9565293942162],
        [108.38569187458, 47.9565451368487],
        [108.38575487119, 47.9565571140196],
        [108.385826685653, 47.9565678896964],
        [108.385893588019, 47.9565743396341],
        [108.385956030646, 47.9565762713778],
        [108.386018232256, 47.9565749160996],
        [108.386077735, 47.9565704833412],
        [108.386134154867, 47.9565626259645],
        [108.386183150832, 47.9565518988511],
        [108.386229751902, 47.9565376131204],
        [108.386277378198, 47.9565190196371],
        [108.386322596111, 47.9564973522711],
        [108.386354639855, 47.9564790951342],
        [108.386380030414, 47.9564619216804],
        [108.386446626111, 47.9564034189826],
        [108.386515914378, 47.956332660324],
        [108.386632784875, 47.9562032568749],
        [108.386675541343, 47.9561492292036],
        [108.386711300186, 47.9560970928067],
        [108.386738959735, 47.9560463989222],
        [108.386779206195, 47.9559635569726],
        [108.386816375176, 47.9559013967321],
        [108.386866461118, 47.9558361356292],
        [108.386927542172, 47.9557686127313],
        [108.386964790293, 47.9557344969495],
        [108.387008553102, 47.9557012957782],
        [108.387049065762, 47.9556740454209],
        [108.387145376858, 47.9556138636889],
        [108.387212754965, 47.9555679856741],
        [108.387323758285, 47.9554885710408],
        [108.387443880731, 47.9553983411606],
        [108.387495786002, 47.955356100004],
        [108.387540800667, 47.9553140791814],
        [108.387559297923, 47.9552929819856],
        [108.387575718645, 47.9552674358435],
        [108.387589204878, 47.9552372402065],
        [108.387598323104, 47.9552083413919],
        [108.387602620065, 47.9551818068949],
        [108.387601915896, 47.9551555152149],
        [108.387595411099, 47.9551311480841],
        [108.387583691135, 47.9551075318872],
        [108.387566630096, 47.9550830910119],
        [108.387544915066, 47.955059287756],
        [108.387520070395, 47.9550400008954],
        [108.387485700105, 47.9550213165805],
        [108.387384563247, 47.9549793722003],
        [108.387309367334, 47.9549452869954],
        [108.387228601918, 47.9549060522725],
        [108.387148512794, 47.9548637814384],
        [108.387107975852, 47.9548377145889],
        [108.387072094701, 47.9548091233424],
        [108.387035885298, 47.9547751046874],
        [108.387003452148, 47.9547388494184],
        [108.386983625694, 47.9547111817757],
        [108.386968252683, 47.9546830177072],
        [108.386955744012, 47.9546512806322],
        [108.386946246272, 47.9546173249296],
        [108.386937941933, 47.9545753733548],
        [108.386932519021, 47.9545315053248],
        [108.386931836435, 47.9544952356666],
        [108.386935490381, 47.9544593626095],
        [108.386942277564, 47.954426814346],
        [108.386952201583, 47.9543951438209],
        [108.386965278625, 47.9543645443883],
        [108.386981877412, 47.9543344126031],
        [108.387003540281, 47.9543022609407],
        [108.38702814843, 47.954271368329],
        [108.387052637869, 47.9542452259365],
        [108.387081248001, 47.9542200548117],
        [108.387175809916, 47.9541507071894],
        [108.387280328225, 47.9540797974448],
        [108.387404245809, 47.9540012569525],
        [108.387630541316, 47.9538641103405],
        [108.387691741081, 47.9538241345762],
        [108.387765611394, 47.9537712283595],
        [108.387815279152, 47.9537383185686],
        [108.387886868784, 47.9536989291623],
        [108.387935564375, 47.9536757131637],
        [108.387966131432, 47.953663340291],
        [108.387993092208, 47.9536546474441],
        [108.388020930721, 47.9536481858151],
        [108.388049501283, 47.9536440480344],
        [108.388087017402, 47.9536410730771],
        [108.388169195652, 47.9536392699364],
        [108.38833127327, 47.9536419750971],
        [108.388484920643, 47.953649157083],
        [108.388704845352, 47.9536639734137],
        [108.388874724589, 47.9536685077954],
        [108.388973236326, 47.9536683881856],
        [108.389064852961, 47.9536652108808],
        [108.389155909318, 47.9536597996601],
        [108.389243899886, 47.9536514368644],
        [108.389290572902, 47.9536443996694],
        [108.389331141319, 47.9536359145658],
        [108.389368628659, 47.9536254671416],
        [108.389406996436, 47.9536120609479],
        [108.389444132141, 47.9535966726484],
        [108.389485270729, 47.9535771843396],
        [108.389543392114, 47.9535468861799],
        [108.389604664724, 47.9535125329771],
        [108.389683987626, 47.9534657601368],
        [108.389738279698, 47.9534312558478],
        [108.389798081916, 47.9533899050202],
        [108.38985505127, 47.953346860769],
        [108.389905964589, 47.9533047374238],
        [108.389947860405, 47.9532661690985],
        [108.389991133084, 47.9532217947501],
        [108.390034181832, 47.9531729399793],
        [108.390078584959, 47.9531179257517],
        [108.390139998762, 47.9530358797022],
        [108.390218387269, 47.9529220902823],
        [108.390271960782, 47.9528300401743],
        [108.390352790949, 47.9526770547023],
        [108.390436171592, 47.9525305902146],
        [108.390508326898, 47.9524127052822],
        [108.39058680084, 47.9522957340609],
        [108.390670804714, 47.9521888712195],
        [108.390721048038, 47.952130399998],
        [108.390763924116, 47.9520840714228],
        [108.390804460158, 47.9520436253131],
        [108.390847273283, 47.9520044256637],
        [108.390891640437, 47.9519675489632],
        [108.390940408873, 47.9519303251245],
        [108.391049266411, 47.9518544673099],
        [108.391161222113, 47.9517806149834],
        [108.391319405666, 47.9516795977353],
        [108.391448861276, 47.951601487119],
        [108.391553095399, 47.9515426489741],
        [108.391659430338, 47.9514868856114],
        [108.391762042984, 47.9514374759588],
        [108.391868663008, 47.9513907849568],
        [108.392024278098, 47.9513292425506],
        [108.392186981644, 47.9512705932633],
        [108.392352602591, 47.9512153470107],
        [108.392519854008, 47.9511647844273],
        [108.392620420696, 47.9511371608513],
        [108.392720797627, 47.9511121156317],
        [108.392820822923, 47.9510926740877],
        [108.393013757179, 47.9510604342917],
        [108.393090720261, 47.9510432671331],
        [108.393158548928, 47.9510232572176],
        [108.393247350685, 47.9509895110571],
        [108.393352253903, 47.9509421977243],
        [108.393459133832, 47.9508894129161],
        [108.393603564053, 47.9508134031161],
        [108.393647398808, 47.9507863892805],
        [108.393684654124, 47.9507583610096],
        [108.393716215831, 47.9507277687716],
        [108.393743895165, 47.9506938679277],
        [108.393804950138, 47.9506006657882],
        [108.393936514658, 47.9503793741089],
        [108.393993594629, 47.950289466186],
        [108.394068553121, 47.9501798244394],
        [108.394098660625, 47.9501425718223],
        [108.394125142062, 47.9501138762544],
        [108.394157701117, 47.9500839971788],
        [108.394194533751, 47.9500550929682],
        [108.394236697566, 47.9500259612292],
        [108.394289970706, 47.9499926773203],
        [108.39435785603, 47.9499529092994],
        [108.394439827436, 47.9499077624333],
        [108.39451879061, 47.9498660770579],
        [108.394590841594, 47.9498306779435],
        [108.394694814914, 47.9497848107205],
        [108.394803527661, 47.9497457621572],
        [108.394935004047, 47.9497062909127],
        [108.395168327756, 47.949641804126],
        [108.395259780714, 47.9496130905717],
        [108.395356617914, 47.9495797859784],
        [108.395611928248, 47.949483965013],
        [108.395976026872, 47.9493372280307],
        [108.396213205975, 47.9492459315546],
        [108.396343452089, 47.9491996470461],
        [108.396482548431, 47.9491526295902],
        [108.396647291639, 47.9490995758848],
        [108.396716284029, 47.9490801280455],
        [108.396761446184, 47.9490697660569],
        [108.396808717249, 47.949061101089],
        [108.396914869626, 47.9490470177058],
        [108.397050878595, 47.9490363976117],
        [108.397161089613, 47.9490323317767],
        [108.397233850162, 47.9490345126327],
        [108.397322285895, 47.9490429482735],
        [108.39740948506, 47.9490538930228],
        [108.397506887033, 47.9490695448237],
        [108.397558874143, 47.9490761368543],
        [108.397609575222, 47.9490786756404],
        [108.397668365703, 47.9490781063695],
        [108.397718124292, 47.9490719622013],
        [108.397763671356, 47.94905910999],
        [108.397819180211, 47.9490356178995],
        [108.397872710557, 47.9490079871289],
        [108.397912231265, 47.9489850283364],
        [108.397944080755, 47.9489634985667],
        [108.39797003339, 47.948942170245],
        [108.397990495665, 47.948920553241],
        [108.398009135913, 47.9488944090498],
        [108.398024011599, 47.9488662503772],
        [108.398036177628, 47.948834342431],
        [108.398044828206, 47.9488011385617],
        [108.398050045174, 47.9487701820983],
        [108.398051056011, 47.9487444057298],
        [108.398049257367, 47.9486933790962],
        [108.398043243601, 47.9486366948276],
        [108.398022650925, 47.9485141082396],
        [108.397995483305, 47.94843418459],
        [108.397984509777, 47.9483937609634],
        [108.397979324286, 47.9483493614339],
        [108.397978388992, 47.9483059754404],
        [108.397980592331, 47.9482742059899],
        [108.397985676198, 47.9482426937454],
        [108.397993564152, 47.9482117219934],
        [108.398004454042, 47.9481803302581],
        [108.398016644353, 47.9481522327394],
        [108.398031188189, 47.9481258817041],
        [108.398047262671, 47.9481029408981],
        [108.398066416432, 47.9480815828988],
        [108.398100304685, 47.9480522973757],
        [108.398141051169, 47.9480239498454],
        [108.398205953442, 47.9479853410507],
        [108.398264967854, 47.9479530706777],
        [108.398322859013, 47.9479246898726],
        [108.398382440897, 47.9478988721353],
        [108.398443201792, 47.9478754510912],
        [108.398502515679, 47.9478560608086],
        [108.398540751255, 47.9478463436339],
        [108.398584863001, 47.9478372568839],
        [108.398674087439, 47.9478244487394],
        [108.398790355391, 47.9478143574467],
        [108.399005666578, 47.9478009098842],
        [108.399090272098, 47.9477919562338],
        [108.399167493285, 47.9477796858839],
        [108.399268351353, 47.9477576129236],
        [108.399379192796, 47.9477279649736],
        [108.399467582663, 47.9476965957214],
        [108.399505706723, 47.9476804708771],
        [108.39953648602, 47.9476647102582],
        [108.399572888778, 47.9476394995633],
        [108.399602867678, 47.9476103579318],
        [108.399630344665, 47.9475745981892],
        [108.3996531137, 47.9475351647162],
        [108.399662570971, 47.9475104531449],
        [108.399668063131, 47.947485166907],
        [108.399680751665, 47.9473679123993],
        [108.399714576067, 47.9472206259312],
        [108.399726037027, 47.9471518466804],
        [108.399736979078, 47.947128854613],
        [108.399753409692, 47.947109812368],
        [108.399779174369, 47.9470887322593],
        [108.399810031908, 47.9470707359258],
        [108.399830281942, 47.9470623245667],
        [108.399852216407, 47.9470554438537],
        [108.399903530823, 47.947046075616],
        [108.399942093753, 47.9470436726274],
        [108.399997482098, 47.9470476080607],
        [108.400057141324, 47.9470564942619],
        [108.400237860089, 47.9470907872101],
        [108.40033165758, 47.9471124455829],
        [108.400423676212, 47.9471374943999],
        [108.400510721593, 47.9471648607698],
        [108.400594702084, 47.94719485316],
        [108.400677050306, 47.9472278879567],
        [108.400757767157, 47.9472639696565],
        [108.400836849941, 47.9473030955614],
        [108.400914303153, 47.9473452683695],
        [108.400990124095, 47.9473904853826],
        [108.401055556069, 47.9474444438061],
        [108.401161458435, 47.946801760393],
        [108.401201152711, 47.9464371203768],
        [108.401246454261, 47.9461578341168],
        [108.401318847887, 47.9460487868221],
        [108.401458967657, 47.9460018718889],
        [108.401681292658, 47.945995278959],
        [108.401954763002, 47.9460406200786],
        [108.402391945932, 47.9461559356479],
        [108.402856683189, 47.9462062922866],
        [108.403555420446, 47.9461855629135],
        [108.403886804433, 47.9461436608013],
        [108.404432093966, 47.9459671283803],
        [108.404882800901, 47.9458040911859],
        [108.405136182189, 47.9457858799145],
        [108.405344731374, 47.9458117588057],
        [108.405522921246, 47.9458599201992],
        [108.405866930814, 47.9460100584175],
        [108.406174272325, 47.9460864540267],
        [108.406654190139, 47.946125653676],
        [108.407001450756, 47.946083271326],
        [108.407283083348, 47.9460107652847],
        [108.407606037988, 47.9458408212969],
        [108.407872221126, 47.9455335922016],
        [108.408123925179, 47.9452481716659],
        [108.408304653837, 47.9450931402363],
        [108.408475120331, 47.9450239347068],
        [108.408823775797, 47.9450028851751],
        [108.409793153231, 47.9449847656345],
        [108.410143213439, 47.9449850498202],
        [108.410436078562, 47.9450832449958],
        [108.410718685119, 47.9452672651722],
        [108.411013661851, 47.9453974663201],
        [108.411240901646, 47.9454655387037],
        [108.411991480323, 47.9455073580781],
        [108.412659846575, 47.945508857248],
        [108.41329293692, 47.9454579511236],
        [108.413716069741, 47.945359839585],
        [108.414078494727, 47.9453062939503],
        [108.414396093905, 47.9452968411763],
        [108.414571476992, 47.945302310853],
        [108.41473379293, 47.9453509300015],
        [108.414963147931, 47.9454510038608],
        [108.415191097291, 47.9455297386066],
        [108.415397536667, 47.9455235926397],
        [108.415601161165, 47.9454747693452],
        [108.415882074298, 47.945391573962],
        [108.416841596063, 47.9452240266676],
        [108.417123209768, 47.9451514981432],
        [108.4172410956, 47.9450090158534],
        [108.41724782163, 47.9448698430688],
        [108.417186102057, 47.9446578800571],
        [108.417129310769, 47.9445206003455],
        [108.4171194542, 47.9443712319468],
        [108.417269801061, 47.9442384722278],
        [108.417472715993, 47.9441789766785],
        [108.417711611901, 47.944182549685],
        [108.418176343763, 47.9442328442704],
        [108.418480168025, 47.9442558606195],
        [108.418701777165, 47.9442385657572],
        [108.418936448059, 47.9441781223226],
        [108.419102668853, 47.9440448868621],
        [108.419354303658, 47.943759442944],
        [108.419476786824, 47.9434457791994],
        [108.419545616437, 47.9432833751277],
        [108.419622898778, 47.9432490021398],
        [108.419735463321, 47.9432670263523],
        [108.419979991683, 47.9433559468196],
        [108.420456697119, 47.9435876067827],
        [108.420702638316, 47.9436978645648],
        [108.421023044278, 47.9437310702328],
        [108.42122947556, 47.9437249143734],
        [108.421621524214, 47.9436383897],
        [108.422006521284, 47.943445174855],
        [108.422331523681, 47.9433071972694],
        [108.422488199971, 47.9432704527692],
        [108.422680866229, 47.9432967750262],
        [108.42297515408, 47.943416275141],
        [108.423411650827, 47.943520841114],
        [108.423620196415, 47.9435466867303],
        [108.426113936409, 47.9434829256965],
        [108.426783684919, 47.9435056812422],
        [108.427185606331, 47.9435685051824],
        [108.427771379745, 47.9437648056013],
        [108.428485266982, 47.944213837099],
        [108.428828622743, 47.9443532356134],
        [108.428958483947, 47.9443921151041],
        [108.429309242927, 47.94440301129],
        [108.429576366756, 47.9443522643456],
        [108.429730920646, 47.9442835030812],
        [108.429952858038, 47.9440309941351],
        [108.430095397884, 47.9437808593992],
        [108.430153967132, 47.943704276731],
        [108.430247829374, 47.9436800903639],
        [108.430359688849, 47.9436874351271],
        [108.430700926706, 47.9437948222733],
        [108.430908769924, 47.9438099857423],
        [108.431128251268, 47.943760660626],
        [108.431250336034, 47.9436821776904],
        [108.43129759271, 47.9434348920067],
        [108.431223119851, 47.9432714231377],
        [108.430944553049, 47.9429091636271],
        [108.430800558099, 47.9426569073904],
        [108.430824995377, 47.9423853597966],
        [108.431043747371, 47.9421650142041],
        [108.431329781244, 47.9419996702487],
        [108.431788012807, 47.9418719341425],
        [108.432180842072, 47.9417176473516],
        [108.432669155057, 47.9414037120118],
        [108.432980122635, 47.9412946314421],
        [108.433235120005, 47.9413012531503],
        [108.433541891345, 47.9414488597771],
        [108.43378137631, 47.9415414656661],
        [108.434405096618, 47.9416323862257],
        [108.434913819717, 47.9416686999506],
        [108.435508958672, 47.9416199512997],
        [108.435964235961, 47.9415444604086],
        [108.436163979884, 47.9415487861476],
        [108.436399810903, 47.9416345032298],
        [108.436674460258, 47.9418427664306],
        [108.437059712736, 47.9420992602727],
        [108.437328904106, 47.9422252121239],
        [108.437530700282, 47.9422604007969],
        [108.437884938739, 47.9422807128847],
        [108.438300428222, 47.9422991876575],
        [108.438732595633, 47.9423377793651],
        [108.439245427734, 47.9424358036695],
        [108.439536368309, 47.9424270820443],
        [108.439716019579, 47.9423598397349],
        [108.439920829383, 47.942209370566],
        [108.440015715053, 47.9420209616981],
        [108.440048668012, 47.9418241010015],
        [108.440162964649, 47.9416969647432],
        [108.44054741673, 47.941479253265],
        [108.440827415253, 47.9413059089406],
        [108.44098286127, 47.9411053736142],
        [108.441000496975, 47.9409089715719],
        [108.440880325067, 47.940716703713],
        [108.440808140084, 47.9405539237247],
        [108.440781890672, 47.940389765975],
        [108.440805680438, 47.9402859617278],
        [108.440892082803, 47.9402008966541],
        [108.442035545604, 47.9396305196328],
        [108.442302950921, 47.9394987869395],
        [108.442469329096, 47.9394628662184],
        [108.443067168715, 47.9394552318735],
        [108.443358091303, 47.9394465003558],
        [108.443554406111, 47.9393993713839],
        [108.443851745362, 47.9392564259434],
        [108.444533499821, 47.9388957573334],
        [108.445013202697, 47.9387267153656],
        [108.445256132964, 47.9386884905815],
        [108.445502484252, 47.9387017097162],
        [108.445798877416, 47.9387752796555],
        [108.446129316215, 47.9388993717087],
        [108.446711588569, 47.9391189861523],
        [108.446993358757, 47.9392033020908],
        [108.447347578328, 47.9392235836016],
        [108.448189028101, 47.9391879848377],
        [108.448786863223, 47.9391803217145],
        [108.449205068659, 47.9392399107933],
        [108.449705318346, 47.9393795035613],
        [108.449895908969, 47.939476864166],
        [108.450082388791, 47.9395124917082],
        [108.45028212462, 47.9395167931655],
        [108.450921783613, 47.9394460057287],
        [108.451665879976, 47.9393308367488],
        [108.452045238297, 47.9392678761117],
        [108.452311929552, 47.9391258308924],
        [108.452484007631, 47.9389453972124],
        [108.452544791009, 47.9387064590359],
        [108.452527184082, 47.9382121520692],
        [108.452511409974, 47.9379755161572],
        [108.452531745444, 47.937820267991],
        [108.452602128186, 47.9377253679314],
        [108.452808251899, 47.9375954536673],
        [108.453063736702, 47.9375156001649],
        [108.453414517266, 47.9374844215688],
        [108.453768726945, 47.9375046850932],
        [108.454311471397, 47.9375914327984],
        [108.454573130046, 47.9376041716952],
        [108.454832730146, 47.9375860449601],
        [108.454983094095, 47.9375402802598],
        [108.455128653864, 47.9374224942528],
        [108.455160174203, 47.9372050552691],
        [108.455133197239, 47.9370306119732],
        [108.455217512278, 47.9369146722744],
        [108.45533656633, 47.936859541135],
        [108.455535604285, 47.9368535435562],
        [108.455784694908, 47.9369078958828],
        [108.455973915864, 47.9369846674085],
        [108.45625294132, 47.9370278060885],
        [108.456573779856, 47.9370078303472],
        [108.456821499013, 47.9370416007893],
        [108.457041342784, 47.9371174487113],
        [108.45729799041, 47.9372849690262],
        [108.457683992922, 47.937551680066],
        [108.457953894756, 47.9376878706987],
        [108.4581883669, 47.9377529663264],
        [108.458372784576, 47.9377577147468],
        [108.458644259325, 47.9376876764452],
        [108.459059222705, 47.9374689811086],
        [108.460100930813, 47.9367571623133],
        [108.461263719145, 47.9360210618226],
        [108.461666786293, 47.9358542618647],
        [108.462302254446, 47.9357216829094],
        [108.46286667076, 47.9356737175681],
        [108.463677425773, 47.935638930892],
        [108.464087361942, 47.9355750061816],
        [108.464449989276, 47.9354918908381],
        [108.46467344922, 47.93539235927],
        [108.46496864089, 47.9352184960368],
        [108.465413656015, 47.9347617618459],
        [108.465603216016, 47.9343849063384],
        [108.465622822136, 47.9342193672301],
        [108.465567944605, 47.93408700681],
        [108.465455959225, 47.9340182266599],
        [108.465252804174, 47.9339625091625],
        [108.465005094909, 47.9339287558075],
        [108.464738636579, 47.9338440216843],
        [108.464580034841, 47.9337663400446],
        [108.464451366138, 47.933677443859],
        [108.464428488284, 47.9335647336256],
        [108.464404232669, 47.9334314478031],
        [108.464446894708, 47.9331518126061],
        [108.464573670339, 47.9329830377371],
        [108.464735193075, 47.9328750687295],
        [108.464944019251, 47.9327862876571],
        [108.465175037098, 47.9327999267752],
        [108.465348257316, 47.9328668579192],
        [108.465625035367, 47.9331059148062],
        [108.465918502137, 47.9333650850307],
        [108.46611185278, 47.9335035707333],
        [108.466255835139, 47.9335920019694],
        [108.466440927307, 47.9336070269428],
        [108.46674367598, 47.9335463316979],
        [108.467592904889, 47.9331701533799],
        [108.467802416348, 47.9330916551558],
        [108.467965999431, 47.9330145463842],
        [108.468053722901, 47.9329500389132],
        [108.46809276337, 47.9328457670186],
        [108.468068498762, 47.9327124820954],
        [108.467964245753, 47.9325300690076],
        [108.467936541238, 47.9323453428634],
        [108.467960961429, 47.9322518232631],
        [108.468165646228, 47.9321013064302],
        [108.468421766851, 47.9320317069977],
        [108.468773875714, 47.932021059924],
        [108.469047373038, 47.931981861174],
        [108.469270807802, 47.9318823224113],
        [108.469475488103, 47.9317318028804],
        [108.46962099841, 47.9316140015849],
        [108.469847186898, 47.9315556131011],
        [108.470614699809, 47.9315633211904],
        [108.470942391178, 47.931646188321],
        [108.471386897288, 47.9318698470159],
        [108.471596256762, 47.9320181479192],
        [108.471737483598, 47.9320654189839],
        [108.471951810028, 47.932058932174],
        [108.472163379137, 47.9320112905887],
        [108.472393013827, 47.9320043397286],
        [108.472594791117, 47.932039468147],
        [108.472836150268, 47.9322074174384],
        [108.472979450042, 47.9322855496384],
        [108.47322715391, 47.932319287705],
        [108.473456099719, 47.9323020450034],
        [108.473605051732, 47.9322356804324],
        [108.473749864165, 47.9321075845974],
        [108.473977560816, 47.931842960884],
        [108.47412444079, 47.9317457297817],
        [108.474182104421, 47.9317391017782],
        [108.474368003281, 47.9317177338864],
        [108.474660253268, 47.931729500616],
        [108.475047114633, 47.9317796360214],
        [108.475739466703, 47.9318102048771],
        [108.476213351865, 47.9317855346748],
        [108.476514006916, 47.9316939504155],
        [108.476781280931, 47.9315621403805],
        [108.477102882992, 47.9313255899041],
        [108.477320774334, 47.9311437289999],
        [108.47738695994, 47.930987085086],
        [108.47732181485, 47.9304736027746],
        [108.477360143956, 47.9303590408371],
        [108.477447851237, 47.9302945270708],
        [108.477735259275, 47.9302342679972],
        [108.478454063105, 47.9302021630994],
        [108.478980874268, 47.930052166974],
        [108.479532772919, 47.9298189349959],
        [108.480305554957, 47.9293333325673],
        [108.481637539941, 47.9285710546105],
        [108.481450516029, 47.9278741888428],
        [108.481484133586, 47.9271821650249],
        [108.480782302661, 47.926474000175],
        [108.479852650979, 47.9259092771915],
        [108.479364278639, 47.925354239007],
        [108.479044630805, 47.9243575581548],
        [108.478500542766, 47.9219209368018],
        [108.477746922582, 47.9207662666499],
        [108.477484036359, 47.9201172097415],
        [108.477515293196, 47.9194746171599],
        [108.477622488787, 47.9187842103231],
        [108.478043272579, 47.9182676999944],
        [108.478831588607, 47.9179510100311],
        [108.480287090077, 47.9175376267601],
        [108.481315982846, 47.9172401193361],
        [108.482040727598, 47.9168106741733],
        [108.482642730178, 47.9163506988257],
        [108.483302271383, 47.9155579707238],
        [108.48345603207, 47.9149489903037],
        [108.483537862283, 47.9141157567369],
        [108.483563492062, 47.9135874688866],
        [108.483220943892, 47.9129676039718],
        [108.482498087717, 47.9125064019489],
        [108.480670748057, 47.9117704471485],
        [108.479323526759, 47.9113790190266],
        [108.478427191362, 47.9110809863985],
        [108.477909834771, 47.910652103312],
        [108.477483308808, 47.9100582099185],
        [108.477500885158, 47.9096967508045],
        [108.477327909555, 47.9089970917424],
        [108.477265481317, 47.9085782064191],
        [108.477444420324, 47.9083037962832],
        [108.477923648358, 47.9078133123345],
        [108.479271293236, 47.9073419039058],
        [108.479910507064, 47.9069662633824],
        [108.479606695393, 47.9064029055697],
        [108.478988281984, 47.9054986255612],
        [108.47858827343, 47.9052114954142],
        [108.478017454842, 47.9050319466671],
        [108.476949070144, 47.9048692916845],
        [108.47582987285, 47.904900348872],
        [108.474575794338, 47.9051511014422],
        [108.47358199941, 47.9051570621488],
        [108.473136610166, 47.9049524160212],
        [108.47261800082, 47.9045513156907],
        [108.472227516986, 47.9040695317835],
        [108.472206485441, 47.9036515547755],
        [108.472308148402, 47.9032641142475],
        [108.472565730424, 47.9030749472511],
        [108.473411684901, 47.9027038950688],
        [108.474664356875, 47.9024809594288],
        [108.477421822159, 47.9019570845518],
        [108.477887475826, 47.9017446448995],
        [108.478362584066, 47.9013375712719],
        [108.478424199317, 47.9009214108945],
        [108.478284477047, 47.9003894888838],
        [108.477416720305, 47.8995075552295],
        [108.476122004127, 47.8988945674304],
        [108.473835009278, 47.8982597261056],
        [108.471287803689, 47.8978696136918],
        [108.470443935639, 47.8973499980041],
        [108.469641429209, 47.8968312879337],
        [108.469249672834, 47.8963773002723],
        [108.468845054356, 47.8953385059673],
        [108.468670218955, 47.8938315947523],
        [108.468243931312, 47.8932376698826],
        [108.467844074744, 47.8929505037628],
        [108.467072147961, 47.892655125034],
        [108.466462883355, 47.8924190008363],
        [108.466056255792, 47.892270851019],
        [108.465709977234, 47.8917343505599],
        [108.465767607589, 47.8914016121947],
        [108.466152619948, 47.8902967393031],
        [108.467246513016, 47.8882333114182],
        [108.467882203301, 47.8870782959266],
        [108.46795337295, 47.8864675105672],
        [108.467895108572, 47.8859652059296],
        [108.467348952992, 47.8852851287058],
        [108.466465346599, 47.8847367697862],
        [108.465369656684, 47.8842950578707],
        [108.46472730602, 47.8838911867289],
        [108.46420489524, 47.8835734652433],
        [108.464097187036, 47.8832370720333],
        [108.464118912858, 47.8827922016988],
        [108.464272785061, 47.8821832455604],
        [108.464581124819, 47.8818003771857],
        [108.465306856127, 47.8813432248101],
        [108.467474480363, 47.8801663710812],
        [108.468072102346, 47.8797898780005],
        [108.468339066994, 47.8794060869214],
        [108.468366177057, 47.8788499974295],
        [108.468311980314, 47.8782642788734],
        [108.46781671377, 47.8773904840836],
        [108.467149371846, 47.8766520606441],
        [108.465668317939, 47.8764801876106],
        [108.464259073098, 47.8765325578314],
        [108.462965662735, 47.876754479036],
        [108.461929727375, 47.8767872386402],
        [108.461185809977, 47.8767707819461],
        [108.460571316713, 47.8766458472281],
        [108.45996634637, 47.8763262776357],
        [108.459205591865, 47.875808415626],
        [108.458563394085, 47.8754045121086],
        [108.458331754807, 47.8750653678725],
        [108.458484308604, 47.8744842241676],
        [108.459055563364, 47.8738010137059],
        [108.45933752061, 47.8731113973731],
        [108.460680597831, 47.8710257085697],
        [108.461247148237, 47.869590853735],
        [108.461535845003, 47.8687622076098],
        [108.461571168575, 47.8680392929791],
        [108.461318601173, 47.8672821753322],
        [108.460323629032, 47.8664807921549],
        [108.46002160971, 47.8658895832377],
        [108.460249958369, 47.8654492859558],
        [108.460563656288, 47.8649552092156],
        [108.461246501625, 47.8645249681528],
        [108.46211498322, 47.8636813123428],
        [108.462350092083, 47.8631019870671],
        [108.462476177933, 47.8622140729212],
        [108.463052669445, 47.8614196199196],
        [108.463482120903, 47.8610951013579],
        [108.463994199373, 47.860772405722],
        [108.465360345104, 47.8607469243311],
        [108.4673489422, 47.8606794967614],
        [108.468267379336, 47.8605049239631],
        [108.46884580439, 47.860517685343],
        [108.469337533001, 47.8606120350175],
        [108.470027725799, 47.860877764897],
        [108.470314232716, 47.860939750669],
        [108.470932627239, 47.8609812184085],
        [108.47151511633, 47.8609105505815],
        [108.472262870235, 47.8608435232101],
        [108.473353320699, 47.8605335269008],
        [108.474530444225, 47.8601419243104],
        [108.475134535031, 47.8596263636658],
        [108.475401338701, 47.8592425519023],
        [108.475593611956, 47.8586900929734],
        [108.475488577436, 47.8582981000773],
        [108.475218287094, 47.8579024703228],
        [108.474697415953, 47.8575569939601],
        [108.474095274877, 47.8571818921307],
        [108.473497197837, 47.8567233727855],
        [108.472788713728, 47.8559840743056],
        [108.472690464593, 47.8554530552144],
        [108.472729671437, 47.8546467176719],
        [108.472705182898, 47.8534492964479],
        [108.473173707201, 47.8523184007736],
        [108.473961870344, 47.8514172171309],
        [108.474745953263, 47.8505994420107],
        [108.475538112994, 47.8496148309598],
        [108.475807559771, 47.8491754069195],
        [108.475791902574, 47.8486462080561],
        [108.475589967903, 47.847695391729],
        [108.475301376357, 47.8468261717904],
        [108.474865922824, 47.8464269060769],
        [108.474273362226, 47.8458571729702],
        [108.474219117818, 47.8452714544142],
        [108.474455351733, 47.8446642951212],
        [108.474759330679, 47.8443648055913],
        [108.474986102826, 47.8439522793743],
        [108.475142414891, 47.8432876902747],
        [108.475345425151, 47.8425127912324],
        [108.475249871285, 47.8419261625624],
        [108.474541554449, 47.8411868757738],
        [108.474030305155, 47.8406467663352],
        [108.47349667713, 47.8397164761345],
        [108.473366601887, 47.8389899138535],
        [108.473348268308, 47.8385163227701],
        [108.473453828931, 47.8380454602299],
        [108.473925668135, 47.8376939997783],
        [108.474645286751, 47.8373479928157],
        [108.475161109098, 47.8369418266041],
        [108.475555729813, 47.83647732317],
        [108.475531976919, 47.836114951244],
        [108.474974068099, 47.835685156245],
        [108.47405125666, 47.8351081521196],
        [108.472775717625, 47.83413368722],
        [108.472337683937, 47.8337900229912],
        [108.471914524136, 47.8331405038313],
        [108.471728323104, 47.832718881871],
        [108.471752648866, 47.8322183956625],
        [108.471894096935, 47.8318596641922],
        [108.472236604636, 47.8316166988516],
        [108.472532412341, 47.8314840425546],
        [108.473158561718, 47.8313586617729],
        [108.473901837, 47.8313750303334],
        [108.474433247297, 47.8314980683812],
        [108.475137930871, 47.8314579091552],
        [108.476135713393, 47.8313406888218],
        [108.477368272028, 47.8306440982466],
        [108.479574763165, 47.8294678713452],
        [108.480306351757, 47.8288715803592],
        [108.480509221723, 47.828096667827],
        [108.480452223591, 47.8275665588496],
        [108.479826599418, 47.8268291192685],
        [108.479103593956, 47.8263957161894],
        [108.478716301816, 47.8258583478845],
        [108.477965144876, 47.8234480631776],
        [108.47728264218, 47.8221805011292],
        [108.47712070036, 47.8212583983565],
        [108.477203770738, 47.820397352356],
        [108.477362669252, 47.8196771455839],
        [108.477930353703, 47.8190494313862],
        [108.478580588723, 47.8184235266245],
        [108.479225422415, 47.8179088401209],
        [108.479527866218, 47.817637138743],
        [108.479641399331, 47.8169994366747],
        [108.479610003099, 47.8159410317532],
        [108.480039870044, 47.8138907123865],
        [108.480234600247, 47.8132826267919],
        [108.479917830244, 47.812997323168],
        [108.479225517743, 47.8127872712157],
        [108.478194902773, 47.8127367859739],
        [108.477003220123, 47.8125992463582],
        [108.476310925609, 47.8123891773187],
        [108.475674747891, 47.8118741562674],
        [108.475127879148, 47.8112219247521],
        [108.474711598262, 47.8104333910882],
        [108.474795219924, 47.8087094842554],
        [108.474985943646, 47.8081848233709],
        [108.475420264034, 47.8077490271959],
        [108.476337736198, 47.8075743707607],
        [108.478134080723, 47.8071685193117],
        [108.479142159583, 47.8068288246906],
        [108.479820037964, 47.8064818680438],
        [108.480292885308, 47.8061025690783],
        [108.480571470097, 47.8054684903786],
        [108.480683614657, 47.804858589952],
        [108.480629321686, 47.8042728695973],
        [108.480451218149, 47.8036844305921],
        [108.480394238004, 47.8031543198161],
        [108.480415765076, 47.8027094377904],
        [108.480558411042, 47.8023228857926],
        [108.480827553849, 47.8018834419673],
        [108.481433573701, 47.8013122195833],
        [108.481955699396, 47.8007669876064],
        [108.482135563805, 47.8004647542451],
        [108.48223154485, 47.8001885139888],
        [108.482090668749, 47.7996843981165],
        [108.481873981599, 47.7990394439153],
        [108.481569389316, 47.7985038994354],
        [108.481561736085, 47.7978078628427],
        [108.481407842298, 47.796718932233],
        [108.481150330423, 47.7952102043875],
        [108.481254372092, 47.7947671326971],
        [108.481402365427, 47.7942693579446],
        [108.481833825071, 47.7938891443686],
        [108.481862457686, 47.7924423681209],
        [108.481755208136, 47.7912431212731],
        [108.481843514367, 47.790270844424],
        [108.482191468362, 47.7890537541275],
        [108.482541701239, 47.7886439195813],
        [108.483307205963, 47.7881875262334],
        [108.483727855756, 47.7880297455763],
        [108.483907662609, 47.7877275077184],
        [108.484051581116, 47.7873131441863],
        [108.48398786235, 47.7869220596054],
        [108.483713827231, 47.7866098671517],
        [108.483150991025, 47.7862913371755],
        [108.482336588363, 47.7860507883133],
        [108.481934764078, 47.7858192911274],
        [108.481737885395, 47.7856201245692],
        [108.481546382859, 47.7853097388534],
        [108.481569231035, 47.78483704979],
        [108.481553509087, 47.7843078446314],
        [108.481657522876, 47.7838647729409],
        [108.481878581631, 47.7835634433982],
        [108.482383051836, 47.7833796732334],
        [108.483091106969, 47.7832560371365],
        [108.486286545688, 47.7829364180813],
        [108.487328650397, 47.7827365716355],
        [108.487710670711, 47.7825222613933],
        [108.48800883464, 47.7823339478535],
        [108.488240573744, 47.7818101620094],
        [108.488311312617, 47.7811993469724],
        [108.488054703662, 47.7805256936059],
        [108.487215200921, 47.779950612231],
        [108.48644481018, 47.779655386387],
        [108.485961851758, 47.7793942898147],
        [108.485159616024, 47.7789035135863],
        [108.484560969713, 47.77847286603],
        [108.484119283878, 47.7782126669811],
        [108.483304999926, 47.777972127112],
        [108.482236502812, 47.7778651752377],
        [108.481298482039, 47.7776219041276],
        [108.480363158333, 47.777323015345],
        [108.47906600769, 47.7768213240449],
        [108.477048400264, 47.7749955393127],
        [108.475461756055, 47.7736523946423],
        [108.474404659647, 47.7724600626818],
        [108.473233310669, 47.7710703610084],
        [108.472684184627, 47.7704737318773],
        [108.471467634824, 47.7691665187199],
        [108.471007778186, 47.7684326764269],
        [108.47107195111, 47.7679608992761],
        [108.471214561103, 47.7675743553722],
        [108.47148224431, 47.7671627338731],
        [108.472282021298, 47.7668463433841],
        [108.473747043891, 47.7664332613859],
        [108.474614466984, 47.7664245271703],
        [108.475061393169, 47.7665735403366],
        [108.475915356109, 47.7668428486186],
        [108.476806533894, 47.767196472839],
        [108.477979696806, 47.7676954661729],
        [108.478720721984, 47.767739591409],
        [108.480244020645, 47.7678287340089],
        [108.480868038629, 47.7677311009097],
        [108.482042983997, 47.7673393769108],
        [108.484918577031, 47.7659272200652],
        [108.486874661836, 47.7647453616092],
        [108.488093414979, 47.7642988661998],
        [108.489302775603, 47.7640469957723],
        [108.490128920713, 47.764037240826],
        [108.491122701252, 47.7639754780859],
        [108.491704076982, 47.763904687951],
        [108.492004794985, 47.7636607504433],
        [108.493264917842, 47.7623522260744],
        [108.495143713112, 47.760194319912],
        [108.496591306843, 47.7584166597011],
        [108.496792284636, 47.7576695056432],
        [108.496817641021, 47.757141198008],
        [108.496595589415, 47.7566074899437],
        [108.496156690579, 47.7562917271815],
        [108.494805475392, 47.7552044998878],
        [108.492471418122, 47.753956598818],
        [108.491791860706, 47.7534963842508],
        [108.491326496621, 47.7528738402556],
        [108.491061950249, 47.7523670264172],
        [108.490512806221, 47.751770480923],
        [108.490359922373, 47.7515166220945],
        [108.489804105375, 47.7510591018961],
        [108.489490322021, 47.7507182156731],
        [108.48934279993, 47.7503531331906],
        [108.489439977973, 47.7500490769035],
        [108.489707422859, 47.7496374077402],
        [108.490050631132, 47.7493665697115],
        [108.490634519567, 47.7492401717965],
        [108.493817142048, 47.7491427482393],
        [108.497028977206, 47.749296386619],
        [108.498346967838, 47.7493529773581],
        [108.499553268069, 47.7491566013961],
        [108.500101235783, 47.7489180319417],
        [108.500369922634, 47.7484785296605],
        [108.500604037746, 47.7478991000635],
        [108.500693218118, 47.7468989891971],
        [108.499843594406, 47.7448206919215],
        [108.49929708899, 47.744168577318],
        [108.498813054079, 47.743935342642],
        [108.498243907331, 47.7437559206992],
        [108.497420750667, 47.7437101290193],
        [108.496884832969, 47.7436984342354],
        [108.496217238335, 47.7438508720202],
        [108.495560315057, 47.7437808597989],
        [108.495073630744, 47.7436032230104],
        [108.494382165405, 47.7433932753794],
        [108.493862277222, 47.7430478979422],
        [108.493232082695, 47.7424217593568],
        [108.492492932603, 47.7414870498875],
        [108.492017175053, 47.7402240779789],
        [108.491286096376, 47.7391225280822],
        [108.490368776198, 47.7384622557285],
        [108.488192408753, 47.7373847231265],
        [108.487065049213, 47.7368033303095],
        [108.48585661669, 47.736192312925],
        [108.484634814845, 47.7358593389374],
        [108.483859718851, 47.7356753277542],
        [108.482919757341, 47.7354876941018],
        [108.482269667111, 47.7352785801424],
        [108.481749939908, 47.7349331514438],
        [108.481052315112, 47.7339992783441],
        [108.480667379196, 47.7325712412698],
        [108.480787766043, 47.7309316233957],
        [108.481084689807, 47.7299082506653],
        [108.481722029448, 47.7286696737665],
        [108.482867275604, 47.7271638921],
        [108.483392632564, 47.7265352174264],
        [108.483702877985, 47.7252337806145],
        [108.483799025405, 47.7240946561435],
        [108.483966864979, 47.7231797839199],
        [108.484525336775, 47.7227188400025],
        [108.485676764871, 47.7219368740875],
        [108.487879718075, 47.7207325748485],
        [108.488496720447, 47.7199110387635],
        [108.489208142642, 47.7188410523727],
        [108.489464955743, 47.7177889454036],
        [108.489544918963, 47.7169834802035],
        [108.489297932753, 47.7161151892646],
        [108.488603084165, 47.7151257497536],
        [108.487690220128, 47.7143820463944],
        [108.486426648371, 47.7132131228873],
        [108.484986287887, 47.7122908240623],
        [108.483203325273, 47.710776452971],
        [108.482730386198, 47.7103207134302],
        [108.482464783123, 47.7098416868444],
        [108.482461103097, 47.709062224642],
        [108.482614504956, 47.7075903348261],
        [108.483158410432, 47.7065723769137],
        [108.484105172616, 47.7048952132436],
        [108.484730067439, 47.7039068592142],
        [108.484964134887, 47.7033274556976],
        [108.485029415775, 47.70282785712],
        [108.48501231067, 47.702326450905],
        [108.484624489728, 47.7018169148188],
        [108.483697179881, 47.7013790439078],
        [108.483128548444, 47.7011995563145],
        [108.482683489252, 47.7010227756806],
        [108.482202601969, 47.7007338693726],
        [108.481926330236, 47.700477287397],
        [108.481616911291, 47.7000529656719],
        [108.481513441592, 47.699633168436],
        [108.481169541741, 47.6990689130999],
        [108.480732551266, 47.698725292938],
        [108.479834451399, 47.6985385496144],
        [108.47893367425, 47.6984074095744],
        [108.47840359495, 47.6982844146941],
        [108.477916048187, 47.6981345183934],
        [108.477310309823, 47.6978706788888],
        [108.476238523889, 47.6970120430714],
        [108.475006056984, 47.6960663546786],
        [108.472919499435, 47.6948791533503],
        [108.471629818561, 47.6942661880342],
        [108.470709482057, 47.693689190204],
        [108.469949863396, 47.693199235956],
        [108.468749999613, 47.6916388888237],
        [108.45908333263, 47.6935555554446],
        [108.452992505, 47.6924893767834],
        [108.29500000005, 47.6648333325923],
        [108.271424231243, 47.6748101065012],
        [108.242749999813, 47.686944443931],
        [108.214645839634, 47.8711406230414],
        [108.205749998664, 47.9294444438061],
        [108.230750000412, 47.988277778197],
        [108.270499999775, 47.9886388892734],
        [108.270864009367, 47.9883069809824],
      ],
    ],
  },
};
